import { SvgIcon, SvgIconProps } from '@mui/material';

const Check = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 32, height: 32, fill: 'none', ...sx }}
      data-testid="checkIcon"
      titleAccess="success"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.3327 16.0003C29.3327 23.3641 23.3631 29.3337 15.9993 29.3337C8.63555 29.3337 2.66602 23.3641 2.66602 16.0003C2.66602 8.63653 8.63555 2.66699 15.9993 2.66699C23.3631 2.66699 29.3327 8.63653 29.3327 16.0003ZM8.23147 17.6835C7.92197 17.3627 7.92197 16.8559 8.23147 16.5351L9.45122 15.2711C9.77868 14.9317 10.3239 14.9317 10.6513 15.2711L13.7508 18.4831C13.8327 18.568 13.969 18.568 14.0508 18.4831L21.3473 10.9215C21.6748 10.5822 22.22 10.5822 22.5475 10.9215L23.7672 12.1856C24.0767 12.5063 24.0767 13.0132 23.7672 13.3339L14.0508 23.4034C13.969 23.4882 13.8327 23.4882 13.7508 23.4034L8.23147 17.6835Z"
        fill="#00844D"
      />
    </SvgIcon>
  );
};

export default Check;
